import { Box, IconButton, useBreakpointValue } from "@chakra-ui/react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

interface ArrowBoxProps {
  children: React.ReactNode;
  onPrev?: () => void;
  onNext?: () => void;
  prevRoute?: string;
  nextRoute?: string;
}

const ArrowBox = ({ 
  children, 
  onPrev, 
  onNext, 
  prevRoute,
  nextRoute
}: ArrowBoxProps) => {
  const navigate = useNavigate();
  const arrowOffset = useBreakpointValue({ base: 2, md: -10 });

  const handlePrev = () => {
    if (onPrev) {
      onPrev();
    } else if (prevRoute) {
      navigate(prevRoute);
    }
  };

  const handleNext = () => {
    if (onNext) {
      onNext();
    } else if (nextRoute) {
      navigate(nextRoute);
    }
  };

  const showPrevArrow = !!onPrev || !!prevRoute;
  const showNextArrow = !!onNext || !!nextRoute;

  return (
    <Box position="relative" width="full" maxW="container.lg" mx="auto">
      {/* Left Arrow - only shown if prevRoute or onPrev exists */}
      {showPrevArrow && (
        <IconButton
          aria-label="Previous item"
          icon={<FaChevronLeft />}
          position="absolute"
          left={arrowOffset}
          top="50%"
          transform="translateY(-50%)"
          zIndex={1}
          borderRadius="full"
          colorScheme="blue"
          onClick={handlePrev}
          _hover={{ transform: "translateY(-50%) scale(1.1)" }}
          transition="all 0.2s ease"
        />
      )}
      
      {/* Right Arrow - only shown if nextRoute or onNext exists */}
      {showNextArrow && (
        <IconButton
          aria-label="Next item"
          icon={<FaChevronRight />}
          position="absolute"
          right={arrowOffset}
          top="50%"
          transform="translateY(-50%)"
          zIndex={1}
          borderRadius="full"
          colorScheme="blue"
          onClick={handleNext}
          _hover={{ transform: "translateY(-50%) scale(1.1)" }}
          transition="all 0.2s ease"
        />
      )}
      
      {/* Children content */}
      {children}
    </Box>
  );
};

export default ArrowBox;